var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewImageOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .view{fill:#dcdcdc;}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "view",
    d: "M180 936q-24 0-42-18t-18-42V364h572v572H180Zm600 0v-60h60q0 24-18 42t-42 18ZM217 833h383L469 660l-99.667 137L308 711l-91 122Zm563-45v-83h60v83h-60Zm0-171v-83h60v83h-60Zm0-170v-83h60v83h-60ZM120 276q0-24 18-42t42-18v60h-60Zm148 0v-60h83v60h-83Zm171 0v-60h83v60h-83Zm170 0v-60h83v60h-83Zm171 0v-60q24 0 42 18t18 42h-60Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewImageOff);
export default __webpack_public_path__ + "static/media/view_image_off.1a5b1c055fca632cb205f774a9c01b08.svg";
export { ForwardRef as ReactComponent };